import { NarrativeSummary } from "models/NarrativesSummary";
import serviceFetch from "services/helpers";
import { AuthStore } from "store/Auth";

export const getNarrativesForUserId = async (
  auth: AuthStore,
  userId: string
): Promise<NarrativeSummary[]> =>
  serviceFetch(auth, `narratives/${userId}/summary`);
